import * as React from "react";
import { forwardRef } from "react";
const SvgPdvStatus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 38 37",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M21 17V27.3573C21 28.3237 20.616 29.2504 19.9326 29.9336C19.2492 30.6167 18.3223 31.0004 17.356 31H8.644C7.67767 31.0004 6.7508 30.6167 6.06738 29.9336C5.38396 29.2504 5 28.3237 5 27.3573V6.644C5 4.63147 6.63147 3 8.644 3H11",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5 25H21",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M15 2.5C15 1.67157 15.6716 1 16.5 1H29.5C30.3284 1 31 1.67157 31 2.5V11.5C31 12.3284 30.3284 13 29.5 13H16.5C15.6716 13 15 12.3284 15 11.5V2.5Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M23 10C24.6569 10 26 8.65685 26 7C26 5.34315 24.6569 4 23 4C21.3431 4 20 5.34315 20 7C20 8.65685 21.3431 10 23 10ZM24.2525 5.94375C24.2746 5.88684 24.2857 5.82892 24.2857 5.76999V5.42857H21.6676V6.06263H23.2405L21.6909 7.94347C21.6533 7.99021 21.6234 8.04 21.6013 8.09284C21.5814 8.14568 21.5714 8.18937 21.5714 8.22392V8.57143H24.2426V7.93737H22.6299L24.1662 6.07787C24.2016 6.04333 24.2304 5.99862 24.2525 5.94375Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgPdvStatus);
export default ForwardRef;
